export class AuditModuleReorderModel {
    auditTemplateId: string;
    moduleId: string;
    zOrder: string;
}
